class GoodsSlider extends HTMLElement {
  constructor() {
    super();
    this.flickity = null;
    this.thumbnails = [];
    this.carousel = null;
  }

  connectedCallback() {
    this.init();
    window.addEventListener('resize', () => this.handleResize());
  }

  init() {
    this.carousel = this.querySelector(".gplp-goods-list__carousel");
    if (!this.carousel) return;

    this.thumbnails = Array.from(this.querySelectorAll(".gplp-goods-list__card-images"));

    this.flickity = new Flickity(this.carousel, {
      cellAlign: 'left',
      accessibility: false,
      prevNextButtons: true,
      pageDots: false,
      resize: false,
      adaptiveHeight: true,
      selectedAttraction: 1,
      friction: 1,
      draggable: false,
      wrapAround: true,
      imagesLoaded: true
    });
    this.flickity.resize();
  }

  handleResize() {
    this.flickity.resize();
    const selected = this.querySelector(".carousel-thumbnail__list-item.is-selected");
    if (selected) this.scrollToThumbnail(selected);
  }
}

// エレメント定義（例: <product-media-slider>）
customElements.define('goods-slider', GoodsSlider);
